(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter-grid-type-3"] && !Shopify.designMode) return;
  try {
    



$("area[rel^='prettyPhoto']").prettyPhoto();
$(".gallery:first a[rel^='prettyPhoto']").prettyPhoto({animation_speed:'normal',theme:'light_square',slideshow:3000, autoplay_slideshow: false,social_tools: false,counter_separator_label: false});
$(".gallery:gt(0) a[rel^='prettyPhoto']").prettyPhoto({animation_speed:'fast',slideshow:10000, hideflash: true});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-model-1"]) return;
  try {
    
jQuery(function($){ 
function dropDown() {
elementClick = '.header_toggle';
elementSlide = '.header_slide_element';
activeClass  = 'active';
$(elementClick).on('click', function(e) {
e.stopPropagation();
var subUl = $(this).next(elementSlide);
$(this).toggleClass(activeClass);

$(elementClick).not(this).removeClass(activeClass);
e.preventDefault();
});
$(document).on('click', elementSlide, function(e) {
e.stopPropagation();
});
$(document).on('click', function(e) {
e.stopPropagation();
if (e.which != 3) {
var elementHide = $(elementClick).next(elementSlide);
// $(elementHide).hide();
$(elementClick).removeClass('active');
}
});
}
dropDown()
});

var sbSearchEl = document.getElementById('sb-search');
if (sbSearchEl && window.UISearch) {
  new UISearch(sbSearchEl);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapas-nuevo"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ip-map-section').forEach(function(sec){
  var wrap = sec.querySelector('.ip-mapwrap');
  var svg = wrap && wrap.querySelector('.ip-map');
  var tip = wrap && wrap.querySelector('.ip-tooltip');
  if(!svg || !tip) return;
  svg.addEventListener('mousemove', function(e){
    var t = e.target;
    if(t && t.classList && t.classList.contains('prov')){
      var r = wrap.getBoundingClientRect();
      tip.textContent = t.getAttribute('data-name');
      tip.style.left = (e.clientX - r.left) + 'px';
      tip.style.top = (e.clientY - r.top) + 'px';
      tip.style.opacity = '1';
    } else {
      tip.style.opacity = '0';
    }
  });
  svg.addEventListener('mouseleave', function(){ tip.style.opacity = '0'; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapas"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ip-map-section').forEach(function(sec){
  var wrap = sec.querySelector('.ip-mapwrap');
  var svg = wrap && wrap.querySelector('.ip-map');
  var tip = wrap && wrap.querySelector('.ip-tooltip');
  if(!svg || !tip) return;
  svg.addEventListener('mousemove', function(e){
    var t = e.target;
    if(t && t.classList && t.classList.contains('prov')){
      var r = wrap.getBoundingClientRect();
      tip.textContent = t.getAttribute('data-name');
      tip.style.left = (e.clientX - r.left) + 'px';
      tip.style.top = (e.clientY - r.top) + 'px';
      tip.style.opacity = '1';
    } else {
      tip.style.opacity = '0';
    }
  });
  svg.addEventListener('mouseleave', function(){ tip.style.opacity = '0'; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-model-1"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
$("#tab").tabpager({
//  maximum visible items
items: 7,
// CSS class for tabbed content
contents: 'contents',
// transition speed
time: 2000,
// initial tab
start: 1,
// top or bottom
position: 'top',
// scrollable
scroll: false
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-bestsellers"]) return;
  try {
    
$(document).ready(function(){
var top_products_count = $('.top-products li').length;
      if(top_products_count > 1) { $('.top_products_nav').css('display','block');}
      else {$('.top_products_nav').css('display','none');}
      var top_products = $(".top-products");
      top_products.owlCarousel({
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:false
      });
      // Custom Navigation Events
      $(".top_products_nav .next").click(function(){
        top_products.trigger('owl.next');
      })
      $(".top_products_nav .prev").click(function(){
        top_products.trigger('owl.prev');
      })             
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
   $(this).html('<i class="fa fa-plus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
     $(this).html('<i class="fa fa-minus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promoimage"]) return;
  try {
    
$(document).ready(function(){
     $("#promo-carousel").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-content-block-1"] && !Shopify.designMode) return;
  try {
    
 jQuery(document).ready(function() {       
        $(".inline").colorbox({inline:true, width:"50%"});
      });

  } catch(e) { console.error(e); }
})();
})();
